import React from 'react';
import type { UserPresenceState } from '@annoteer/sync-layer';
import { PresenceAvatar } from './PresenceAvatar.js';

export interface UserAvatarStackProps {
  users: UserPresenceState[];
  maxVisible?: number;
}

function areUsersEqual(prev: UserAvatarStackProps, next: UserAvatarStackProps): boolean {
  if (prev.users.length !== next.users.length) return false;
  for (let i = 0; i < prev.users.length; i++) {
    if (prev.users[i].clientId !== next.users[i].clientId) return false;
    if (prev.users[i].currentPage !== next.users[i].currentPage) return false;
  }
  return true;
}

export const UserAvatarStack = React.memo(function UserAvatarStack({
  users,
  maxVisible = 3,
}: UserAvatarStackProps) {
  if (users.length === 0) return null;

  const visible = users.slice(0, maxVisible);
  const remaining = users.length - maxVisible;

  return (
    <div className="avatar-stack">
      <div className="avatar-stack__avatars">
        {visible.map((user, i) => (
          <div
            key={user.clientId}
            className="avatar-stack__item"
            style={{ zIndex: visible.length - i, marginLeft: i > 0 ? -8 : 0 }}
          >
            <PresenceAvatar user={user} showPage />
          </div>
        ))}
        {remaining > 0 && (
          <div className="avatar-stack__overflow" style={{ zIndex: 0, marginLeft: -8 }}>
            +{remaining}
          </div>
        )}
      </div>
      <span className="avatar-stack__count">
        {users.length} {users.length === 1 ? 'viewer' : 'viewers'}
      </span>
    </div>
  );
}, areUsersEqual);
